export default function Go_Variables() {
  return (
    <div>
      <h1>Go_Variables </h1>
      <p>Variables</p>
    </div>
  );
}
